// DS: 1.15.6
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import UserAvatar from '../Avatar/UserAvatar';
import UserLink from '../Link/UserLink';
import BasicUserName from '../BasicUserName';
import Timestamp from '../../Timestamp';
import s from './IdentityVertical.scss';
const IdentityVertical = ({ user, size, lastSaleTimestamp, withDetails = true, withLinks = true, className, avatarClassName, usernameClassName })=>{
    var _user_stats;
    const { t } = useTranslation();
    var _user_stats_watchers;
    const watchersCount = (_user_stats_watchers = (_user_stats = user.stats) === null || _user_stats === void 0 ? void 0 : _user_stats.watchers) !== null && _user_stats_watchers !== void 0 ? _user_stats_watchers : 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[size], className)
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        className: classnames(s['avatar'], avatarClassName),
        user: user,
        size: size === 'medium' ? 40 : 72,
        withLink: withLinks
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['username-and-details']
    }, withLinks ? /*#__PURE__*/ React.createElement(UserLink, {
        className: classnames(s['username'], usernameClassName),
        user: user,
        useCoreRibbon: true
    }) : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['username'], usernameClassName)
    }, /*#__PURE__*/ React.createElement(BasicUserName, {
        user: user,
        useCoreRibbon: true
    })), withDetails && /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['detail']
    }, t('avatar.watchers', {
        formattedCount: shortenNumber(watchersCount),
        count: watchersCount
    })), lastSaleTimestamp && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Timestamp, {
        className: s['detail'],
        timestamp: lastSaleTimestamp
    })))));
};
IdentityVertical.displayName = 'IdentityVertical';
export default IdentityVertical;

//# sourceMappingURL=IdentityVertical.js.map